if (!customElements.get("mobile-menu")) {
  class MobileMenu extends HTMLElement {
    constructor() {
      super();

      this.mobileMenu = this.querySelector(".mobile-menu");

      document.addEventListener(
        "toggle-mobile-menu",
        this._handleToggleMobileMenu.bind(this)
      );
    }

    _handleToggleMobileMenu(e) {
      if (this.mobileMenu.classList.contains("drawer--in-left")) {
        // OUT
        document.documentElement.classList.remove("overflow-hidden");
        this.mobileMenu.classList.replace(
          "drawer--in-left",
          "drawer--out-left"
        );
      } else if (this.mobileMenu.classList.contains("drawer--out-left")) {
        // IN
        document.documentElement.classList.add("overflow-hidden");
        this.mobileMenu.classList.replace(
          "drawer--out-left",
          "drawer--in-left"
        );
      } else {
        // IN
        document.documentElement.classList.add("overflow-hidden");
        this.mobileMenu.classList.add("drawer--in-left");
      }
    }

    connectedCallback() {}
    disconnectedCallback() {
      document.documentElement.classList.remove("overflow-hidden");
    }
  }

  customElements.define("mobile-menu", MobileMenu);
}

if (!customElements.get("mobile-menu-trigger")) {
  class MobileMenuTrigger extends HTMLElement {
    constructor() {
      super();

      this.state = {
        isOpen: false,
      };

      this.trigger = this.querySelector(".mobile-menu__trigger");
      this.trigger.addEventListener("click", this._handleTrigger.bind(this));
    }

    _handleTrigger(e) {
      e.preventDefault();
      this.state.isOpen = !this.state.isOpen;
      document.dispatchEvent(
        new CustomEvent("toggle-mobile-menu", { detail: this.state.isOpen })
      );

      if (this.state.isOpen) {
        // if (!this.trigger.classList.contains("fixed")) {
        //   this.trigger.classList.replace(
        //     "mobile-menu__trigger-hamburger",
        //     "mobile-menu__trigger-x"
        //   );
        // }
      } else {
        // if (!this.trigger.classList.contains("fixed")) {
        //   this.trigger.classList.replace(
        //     "mobile-menu__trigger-x",
        //     "mobile-menu__trigger-hamburger"
        //   );
        // }
      }
    }
  }

  customElements.define("mobile-menu-trigger", MobileMenuTrigger);
}
